module.exports = __webpack_public_path__ + "img/dielectric_window_set.71bc5d25.webp";